import { useEffect } from 'react'
import { isWeb } from 'tamagui'
import { useLocalSearchParams } from 'expo-router'
import { useThemeParams } from '@hooks/useThemeParams'
import { LoadingScreen } from '@components/LoadingScreen'
import { CoursePreview } from '@components/ProductPage/CoursePreview'
import { NotFoundState } from '@components/ProductPage/NotFoundState'
import { useGetProductCoursePreview } from '@services/api/graphql/queries/getProductPage'

const schoolUrl = isWeb ? window.location.hostname : ''

// Preview de um curso do combo (/:slug/courses/:id). Servida só no web: é o
// nginx (flag members_page_product + slug-check) que roteia o path.
export default function CoursePreviewPage() {
  const { slug, id } = useLocalSearchParams<{ slug: string; id: string }>()
  const { loading: themeParamsLoading } = useThemeParams()
  const { data, loading } = useGetProductCoursePreview(
    schoolUrl,
    isWeb ? (slug ?? '') : '',
    isWeb ? (id ?? '') : '',
  )
  const preview = data?.coursePreview ?? null

  useEffect(() => {
    if (!isWeb || !preview?.name) return
    document.title = preview.name
  }, [preview])

  if (!isWeb) return <NotFoundState />

  if (loading || themeParamsLoading) return <LoadingScreen />

  if (!preview) return <NotFoundState />

  return (
    <CoursePreview
      preview={preview}
      productSlug={slug ?? ''}
      schoolUrl={schoolUrl}
      videoCover={data?.videoCover ?? null}
    />
  )
}
